<template>
  <div>
    The additional systems allow to compute the contribution of
                    operation (energy consumption and attitude modification) of
                    a payload and/or an antenna to the overall power consumption
                    of the battery.
                    <br />
                    <br />
                    The antenna allows the communication between the spacecraft
                    and ground stations, when the last ones are visible.
                    <br />
                    The payload will operate when the spacecraft enters an
                    interest zone. During this time the spacecraft will be in
                    NADIR pointing.
                    <br />
                    <br />
                    If this mode is selected both the antenna and its direction,
                    or the payload and its direction must be selected.
                    <br />
                    If an attitude model is not selected, the simulation will
                    consider the spacecraft as infinite agile. If the attitude
                    is selected the user can define all parameter for attitude
                    simulation, except :
                    <br />
                    <ul>
                      <li>
                        Propulsion system disturbance torque, which depends on
                        propulsion system.
                      </li>
                      <li>
                        Inertia parameter which depends on geometry, see
                        spacecraft shape for more details.
                      </li>
                    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipAdditionalSystem'
}
</script>
